import { useState } from "react";
import HeroImg from "../components/heroImg/HeroImg";
import RestaurantList from "../components/restaurantBtns/RestaurantList";
import NavBar from "../components/ui/navbar/Navbar.js";

import "./Home.css";

const Pickup = (params) => {
  // In case of error and destruction(the button inside the navbar not working) change the state to 0
  const [serviceTypeNum, setServiceTypeNum] = useState(1);

  const restaurantServiceTypeParent = (type) => {
    if (type === "delivery") {
      setServiceTypeNum(0);
    } else {
      setServiceTypeNum(1);
    }
  };

  return (
    <div className="home-view-outter-wrapper">
      <div className="home-div-border"></div>
      <div className="home-view-inner-wrapper">
        <a href="#main" className="skip-to-main">
          Skip to main content
        </a>
        <NavBar restaurantServiceTypeParent={restaurantServiceTypeParent} />

        <div className="home-view-wrapper" id="main" aria-label="main-view">
          <HeroImg />
          <RestaurantList serviceTypeChild={serviceTypeNum} id="main" />
        </div>
      </div>
    </div>
  );
};

export default Pickup;
